<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Claude Filion was born and raised in Ontario and is a graduate of York University, Cambridge University, and McGill University. He has been a lawyer since 1986. He has been a public speaker since 1998. He loves animals, and is devoted to the dogs and birds who share his home. He also enjoys reading, writing, walking his dogs, and playing tennis and pickleball.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?763a9824